module.exports = __webpack_public_path__ + "static/us-enterprise-campaign-mtc-3cb09dfb559065b1088bfe26871aebf5.gif";